import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const External20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 2.75H9V1.25H2.5C1.80964 1.25 1.25 1.80964 1.25 2.5V17.5C1.25 18.1904 1.80964 18.75 2.5 18.75H17.5C18.1904 18.75 18.75 18.1904 18.75 17.5V11H17.25V17.25H2.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M17.25 3.81071L8.53039 12.5303L7.46973 11.4697L16.1894 2.75H12V1.25H18.75V8H17.25V3.81071Z'
      fill='currentColor'
    />
  </Svg>
);

External20.displayName = 'External20';
export default External20;
